import Modal from "@components/ModalTemplate";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import "./style.scss";
import ShowMoreButton from "../ShowMoreButton";
import { useState, useMemo } from "react";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { getBalanceList } from "@api/balance";

function formatDate(timestamp) {
  const date = new Date(timestamp);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}

const HistoryModal = NiceModal.create(() => {
  const modal = useModal();
  const yearly = modal.args?.yearly;

  const { data: listData, fetchNextPage } = useInfiniteQuery({
    queryKey: ["consumer-balance-list"],
    queryFn: ({ pageParam = 0 }) =>
      getBalanceList({ limit: 10, offset: pageParam }),
    getNextPageParam: (lastPage, pages) => {
      const nextOffset = pages.flatMap((p) => p.balances).length;
      return nextOffset < lastPage.count ? nextOffset : undefined;
    },
  });

  const totalCount = listData?.pages[0].count ?? 0;

  const combinedItems = useMemo(() => {
    const allBalances = listData?.pages.flatMap((page) => page.balances) ?? [];

    const migrationItems = allBalances.filter(
      (item) =>
        item.activation?.ident === "migration" ||
        item.activation?.ident === "migration_undo_order"
    );

    const otherItems = allBalances.filter(
      (item) =>
        item.activation?.ident !== "migration" &&
        item.activation?.ident !== "migration_undo_order"
    );

    if (!migrationItems.length) return otherItems;

    const migrationValue = migrationItems.reduce(
      (acc, item) => acc + item.value,
      0
    );
    const migrationOldestDate = migrationItems.reduce((oldest, item) => {
      const itemDate = new Date(item.created);
      return !oldest || itemDate < oldest ? itemDate : oldest;
    }, null);

    const migrationItem = {
      uuid: "migration",
      title: "Migrationspunkte",
      value: migrationValue,
      created: migrationOldestDate,
    };

    return [...otherItems, migrationItem].sort(
      (a, b) => new Date(b.created) - new Date(a.created)
    );
  }, [listData]);

  const date = new Date();
  const year = date.getFullYear();

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => modal.hide()}
      onAfterClose={() => modal.remove()}
      innerClass={"history-modal"}
    >
      <div className="user-history-wrapper">
        <p className="history-modal-title">Punktehistorie</p>

        <div className="history-scroll">
          {combinedItems.map((item) => (
            <div className="user-history-item-wrapper" key={item.uuid}>
              <div className="user-history-item">
                <p className="user-history-name">
                  {item.title ||
                    item.externalOrder?.touchpoint ||
                    item.catalogue?.content?.title ||
                    item.activation?.content?.title ||
                    item.activation?.ident}
                  <span className="user-history-date">
                    {formatDate(item.created)}
                  </span>
                </p>
                <p
                  className={`user-history-points ${
                    item.value < 0 ? "red" : ""
                  }`}
                >
                  {item.value < 0 ? "" : "+"}
                  {item.value} P
                </p>
              </div>
              <div className="underline"></div>
            </div>
          ))}
        </div>

        {combinedItems.length < totalCount && (
          <div className="show-more-wrapper">
            <ShowMoreButton
              showMore={false}
              setShowMore={() => fetchNextPage()}
              copyMore="Mehr anzeigen"
              copyLess="Mehr anzeigen"
            />
          </div>
        )}
      </div>

      <div className="history-balance">
        <div className="history-balance-item">
          Punkte im Jahr {year} (insgesamt)
          <br />
          <p>
            {yearly?.earned}
            <span>p</span>
          </p>
        </div>
        <div className="history-balance-item">
          Ausgegeben im Jahr {year} (insgesamt)
          <br />
          <p>
            {yearly?.used}
            <span>p</span>
          </p>
        </div>
      </div>
    </Modal>
  );
});

export default HistoryModal;
